import React from 'react';
import { hot } from 'react-hot-loader';

function Fields(props) {
	return (
		<>
			<p className="light-gray">{props.heading || ''}</p>
			<p className={props.className} id={props.id}>
				{props.value || ''}
			</p>
		</>
	);
}

export default hot(module)(Fields);
